import React from 'react';
import { Row, Col, Alert, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

export default class ChipUploadComponent extends React.Component {

  componentDidMount() {
  }

  handleSubmit() {
    this.props.uploadFile(this.uploadFile);
  }

  render() {

    let alertDiv = null;
    if (this.props.alertStyle || this.props.alertMessage) {
      alertDiv = (
        <Alert bsStyle={this.props.alertStyle} onDismiss={this.props.cleanAlert}>
          {this.props.alertMessage}
        </Alert>
      );
    }

    return (
      <div>
        <h4>晶片資料匯入</h4>
        <Row>
          <Col xs={12} sm={6} md={6}>
            {alertDiv}
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col xs={12} sm={6} md={6}>
            <FormGroup controlId="chip_upload" >
              <ControlLabel>晶片資料匯入</ControlLabel>
              <FormControl
                type="file"
                onChange={(event) => {
                  this.uploadFile = event.target.files[0];
                }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6} md={6}>
            <Button bsStyle="info" onClick={(event) => {
              this.handleSubmit();
            }}>上傳</Button>
          </Col>
        </Row>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/ChipUploadComponent.jsx